import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { MasterService } from '../service/master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'maintenance-app',
    templateUrl: './maintenance.component.html',
    styleUrls: ['maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {
    title : string = 'マスタメンテナンス';
    selected_event_id: number = null;
    event:any=[];
    isLoaded : boolean = false;

    constructor(
        private commonService: CommonService,
        private masterService: MasterService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) { }

    ngOnInit(): void {
        this.selected_event_id = +this.route.snapshot.paramMap.get('eid');
        this.getList();
    };
    getList(): void {
        this.masterService.getEvent(this.selected_event_id)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                // this.event = res["fuel_results"]['event'][0];
                this.event = res["fuel_results"]['event'];
                if (this.event.length==0){
                    //対象のイベントがないメッセージを表示し、イベント一覧画面へ飛ばす
                    this.commonService.modalOpens(11007,modalresult=>{
                        this.router.navigate(["/event"]);
                        });
                    }
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });  
    }
}



// WEBPACK FOOTER //
// ./src/app/a0110-maintenance/maintenance.component.ts